<template>
    <section 
        class="articles articles--featured"
        :class="[
            data.collapsed ? 'is-' + data.collapsed : null
        ]"
    >
        <div :class="`
                container main 
                ${isMobile ? 'mobile' : 'desktop'} 
                ${data.style.indexOf('full-separated-row')>=0 ? 'separated-row-view' : '' }
                ${data.style.indexOf('aligned-bottom-cards')>=0 ? 'grid-view' : '' }
            `"
        >
            <div v-if="data.showTitle" class="container title">
                <h2 v-if="data.titleUseH2" class="element-title">{{data.title}}</h2>
                <h4 v-else class="medium element-title">{{data.title}}</h4>
            </div>
            
            <div v-if="data.style.indexOf('masonry')>=0" class="masonry--wrapper">
                <div :class="data.style">
                    <masonry-wall :items="elementItems" :ssr-columns="1" :gap="30">
                        <template #default="{ item, index }">
                            <card :data="item"></card>
                        </template>
                    </masonry-wall>
                </div>
            </div>

            <div v-else-if="data.style.indexOf('full-separated-row')>=0" class="full-separated-row--wrapper">
                <div class="row" :class="data.style">
                    <div
                        v-for="(item, index) in data.items"
                        :key="index"
                        :class="`display-flex card-no-border margin-bottom ${data.columns}`"
                    >
                        <card :data="item"></card>
                    </div>
                </div>
            </div>
            
            <div v-else-if="
                    data.style.indexOf('default') >= 0 || 
                    ( data.style.indexOf('aligned-bottom-cards')>=0 && countItems() > data.columnsCount ) 
                " 
                class="aligned-bottom-cards--wrapper"
            >
                <div class="row" :class="data.style">
                    <div
                        v-for="(item, index) in data.items"
                        :key="index"
                        :class="`display-flex card-no-border margin-bottom ${data.columns}`"
                    >
                        <card :data="item"></card>
                    </div>
                </div>
            </div>

            <div v-else class="row items" :class="data.style">
                <swiper
                    :slides-per-view="settings.slidesPerView"
                    :space-between="settings.spaceBetween"
                    :direction="settings.direction"
                    :breakpoints="settings.breakPoints"
                    :pagination="settings.pagination"
                    :modules="modules"
                    @swiper="onSwiper"
                    @breakpoint="onBreakpointChange"
                >
                    <swiper-slide 
                        v-for="(item, index) in data.items"
                        :key="index"
                        :class="isMobile ? '' : data.columns"
                    >
                        <card :data="item"></card>
                    </swiper-slide>
                </swiper>
            </div>

        </div>
    </section>
</template>

<script>
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import Card from "../Cards/Card";
import 'swiper/css/pagination';

export default {
    name: "v-tiles",
    components: {
        Card,
        Swiper,
        SwiperSlide,
    },
    props: {
        data: {
            type: Object
        }
    },
    data() {
        return {
            isMobile: false,
            swiperObj: null,
            settings: {
                slidesPerView: 1.3,
                spaceBetween: 24,
                direction: 'horizontal',
                pagination: {
                    clickable: true,
                    enabled: true,
                },
                breakPoints: {
                    992: {
                        spaceBetween: 0,
                        enabled: false,
                        pagination: {
                            enabled: false,
                        },
                    },
                },
            },
            elementItems: []
        };
    },
    methods: {
        onSwiper(swiper) {
            this.swiperObj = swiper;
        },
        onBreakpointChange(_, breakpoint) {
            this.isMobile = breakpoint.enabled;
        },
        countItems() {
            let arr = [];
            if (typeof this.data.items.forEach !== 'function') {
                const obj = this.data.items;
                Object.keys(obj).forEach((key) => {
                    arr.push(obj[key]);
                });
            } else {
                arr = this.data.items;
            }
            return arr.length;
        }
    },
    setup() {
        return {
            modules: [
                Pagination,
            ],
        }
    },
    mounted() {
        let app = this;
        app.elementItems = this.convertItemsObjToArray(app.data.items)
    }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";

.element-title {
    margin-top: 0;
    margin-bottom: 3rem;
}

.articles--featured {
    margin: 2rem 0;

    @media #{$md} {
        margin: 120px  0;
    }

    &.is-collapsed {
        margin-top: 0;
        margin-bottom: 0;
    }
}

.container-mobile-width {
    min-width: 42em;

    @media #{$md} {
        min-width: inherit;
    }

    .full-separated-row{
        min-width: 62em;
        @media #{$md} {
            min-width: inherit;
        }

    }
}

.HomePage {
    .container-mobile-width {
        min-width: 62em;

        @media #{$md} {
            min-width: inherit;
        }
    }
}

</style>
